import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

import './design/tokens.css'
import './design/motion.css'
import './design/grain.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.mount('#app')

// Signal the inline loader in index.html that the SPA has mounted.
// The loader awaits this + document.fonts.ready + hero-panorama decode,
// then crossfades out. Flag covers the case where mount() resolves
// before the loader's listener attaches.
window.__evxAppReady = true
window.dispatchEvent(new Event('evx:ready'))
